<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">Inbox AI Settings</h2>
      </sbnb-page-header>
      <h2>Inbox AI Settings</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'gx-inbox-ai'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'gx-inbox-ai'"></sbnb-helptext-wrapper>

    <div class="flex flex-col">
      <div class="flex flex-col">
        <sbnb-loading-spinner *ngIf="isLoading"></sbnb-loading-spinner>

        <div *ngIf="settingsGroups$ | async as groups" class="overflow-x-auto w-full">
          <!-- Add New Group Button -->
          <div class="flex justify-end mb-4">
            <sbnb-button label="+ Add new" size="mini" (clicked)="createNewGroup()"></sbnb-button>
          </div>

          <table mat-table class="w-full" [dataSource]="groups">
            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="w-[80px]">Status</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.enabled ?? element.settings?.scheduled_autoreply_enabled"
                  [disabled]="true"
                  class="pointer-events-none"></mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Group Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="flex flex-col md:flex-row md:items-center gap-2 py-2">
                  <span class="font-medium">{{ element.name }}</span>
                </div>
              </td>
            </ng-container>

            <!-- Hosts Column -->
            <ng-container matColumnDef="hosts">
              <th mat-header-cell *matHeaderCellDef fxHide.lt-md class="w-[120px]">Hosts</th>
              <td mat-cell *matCellDef="let element" fxHide.lt-md>
                <sbnb-hosts
                  [allHosts]="element.all_hosts"
                  [hosts]="element.host_list"
                  [ruleName]="element.name"></sbnb-hosts>
              </td>
            </ng-container>

            <!-- Properties Column -->
            <ng-container matColumnDef="properties">
              <th mat-header-cell *matHeaderCellDef fxHide.lt-md class="w-[120px]">Properties</th>
              <td mat-cell *matCellDef="let element">
                <sbnb-avatar-group
                  [items]="element.property_list"
                  [allItems]="element.all_properties"
                  [itemsForLabel]="element.name"></sbnb-avatar-group>
              </td>
            </ng-container>

            <!-- Platforms Column -->
            <ng-container matColumnDef="platforms">
              <th mat-header-cell *matHeaderCellDef fxHide.lt-md class="w-[140px]">Platforms</th>
              <td mat-cell *matCellDef="let element" fxHide.lt-md>
                <sbnb-scoping-icons
                  class="flex"
                  [showTooltips]="false"
                  [scoped]="[
                    element.all_platforms ||
                    element.platforms?.includes('direct') ||
                    element.platforms?.includes('manual') ||
                    element.platforms?.includes('gvr')
                      ? 'hospitable'
                      : null,
                    element.all_platforms || element.platforms?.includes('airbnb') ? 'airbnb' : null,
                    element.all_platforms || element.platforms?.includes('homeaway') ? 'homeaway' : null,
                    element.all_platforms || element.platforms?.includes('booking') ? 'booking' : null,
                    element.all_platforms || element.platforms?.includes('agoda') ? 'agoda' : null
                  ]"></sbnb-scoping-icons>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" fxHide.lt-md></tr>
            <tr
              class="hover:bg-smoke-lighter cursor-pointer border-b border-smoke"
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="onRowClick(row)"></tr>
          </table>

          <div *ngIf="groups.length === 0" class="text-center py-6">
            <p>No settings groups found.</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
